<template>
  <select class="select2-control">
    <!-- see https://select2.org/placeholders -->
    <option v-if="!multiple"></option>
    <slot></slot>
  </select>
</template>

<script>
import "select2";
import "select2/dist/css/select2.css";

export default {
  name: "Select2",
  props: {
    /**
     * @see https://select2.org/configuration/options-api
     */
    name: "",
    value: null,
    options: {
      Object,
    },
    width: {
      type: String,
      default: "100%",
    },
    allowClear: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Boolean,
      default: false,
    },
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
    minimumInputLength: {
      type: Number,
      default: 0,
    },
    noResultsString: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
    },
    /**
     * Pass a function that gets called before the component returns it to the parent
     */
    dataTransformer: {
      type: Function,
    },
    /**
     * Pass a function that gets executed after value change happend
     */
    afterChange: {
      type: Function,
      default: () => {},
    },
    tags: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /**
       * Used for the destroy method as this.$el didnt have the select2 element
       */
      selectEl: null,
    };
  },
  mounted() {
    let placeholder = this.globals.lang.G00000;
    if (this.placeholder && this.placeholder.length > 1) {
      placeholder = this.placeholder;
    }

    let options = {
      width: this.width,
      allowClear: this.allowClear,
      tags: this.tags,
      multiple: this.multiple,
      placeholder,
      closeOnSelect: this.closeOnSelect,
      tags: this.tags,
      language: {
        noResults: () => {
          return this.noResultsString || this.globals.lang.G00000;
        },
      },
    };

    let vm = this;
    let select = $(this.$el);
    select.select2(options).on("change", (event) => {
      if (select.val() === [] && !this.multiple) return;
      if (!options.allowClear && select.val() == null) return;
      vm.$emit("input", select.val());
      this.afterChange(select.val(), this.value, event);
    });
    select.val(this.value).trigger("change");
  },
  watch: {
    options: function (options) {
      // update options
      $(this.$el).empty().select2({ data: options });
    },
  },
  methods: {
    clearSelection() {
      this.setCurrentSelected(this.$el, null);
    },
    setCurrentSelected(selEL, data) {
      if (!data || data.length <= 0) {
        selEL.val(null).trigger("change");
        return;
      }
      if (this.multiple) {
        selEL.val(data);
        selEL.trigger("change");
      } else {
        selEL.val(data);
        selEL.trigger("change");
      }
    },
    fetchdata(el) {
      const data = $(el).select2("data");
      if (this.dataTransformer) {
        return this.dataTransformer(data);
      }

      if (this.multiple) {
        return data.map((el) => el.id);
      } else {
        return data[0].id;
      }
    },
    addEvents(el) {
      const that = this;
      $(el).on("select2:select", (e) => {
        const data = that.fetchdata(el);
        that.$emit("change", data);
      });

      $(el).on("select2:unselect", () => {
        const data = that.fetchdata(el);
        that.$emit("change", data);
      });
    },
  },
};
</script>

<style>
.select2-control ~ .select2.select2-container {
  margin: 3px 0 7px 0;
  padding-top: 7px;
  float: left;
}
.select2-container--default.select2-container--focus
  .select2-selection--multiple {
  border: none;
}
.select2-control ~ .select2-container--default .select2-selection {
  border: solid #eee !important;
  border-width: 0 1px 1px 1px !important;
  border-radius: 0 !important;
  min-height: 28px;
  line-height: normal;
}
.select2-control ~ .select2-container--default .select2-selection__choice {
  border: 1px solid #d2d2d2 !important;
  border-radius: 0 !important;
  margin-top: 4px !important;
}
.select2-selection__rendered {
  text-align: left;
  font-size: 16px;
}
.select2-control ~ .select2-container--default .select2-selection__arrow {
  top: 7px !important;
}
.select2-control ~ .select2-container--disabled .select2-selection {
  cursor: not-allowed !important;
}
.select2-container--default .select2-search--dropdown .select2-search__field {
  border: solid #d2d2d2 !important;
  border-width: 0 0 1px 0 !important;
}
.select2-container--default
  .select2-selection--single
  .select2-selection__placeholder {
  color: lightgray !important;
}
.select2-container--default
  .select2-search--inline
  .select2-search__field::placeholder {
  color: lightgray !important;
}
.select2-container--default .select2-results__option[aria-disabled="true"] {
  color: lightgray !important;
}
.select2-container--default > .select2-dropdown {
  border-radius: 0 !important;
}
.select2-container--default
  .select2-selection--multiple
  .select2-selection__clear {
  margin-top: 4px !important;
}
.select2-container--open .select2-dropdown--above {
  border-bottom: 1px solid #ddd !important;
}
</style>



// WEBPACK FOOTER //
// Select2.vue?636b3d06